<template>
  <div class="row justify-content-center personalLoan-steps">
   <step-back-button v-if="canGoPrevious" @click="this.onPrevious"/>
   <transition v-bind:name="transitionName" mode='out-in'>
    <component :is='currentStepComponent' class="form-container" :current-user="currentUser" @on-submit="this.updateUser" @loading-toggle="handleLoadingToggle"></component>
   </transition>
  </div>
</template>

<style lang="scss" scoped>
  .form-container {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import StepBackButton from '@/components/StepBackButton'
import * as mutationTypes from '@/store/mutation-types.js'

// COMPONENTS STEPS - EMPRESTIMO SOCIAL
import NomeCompletoStep from '@/components/AdditionalInformationSocial/NomeCompletoStep.vue'
import TelefonesStep from '@/components/AdditionalInformationSocial/TelefonesStep.vue'
import NaturezaOcupacaoStep from '@/components/AdditionalInformationSocial/NaturezaOcupacaoStep.vue'
import RendaExtraStep from '@/components/AdditionalInformationSocial/RendaExtraStep.vue'
import OutrosEmprestimosStep from '@/components/AdditionalInformationSocial/OutrosEmprestimosStep.vue'
import InformacoesSocioStep from '@/components/AdditionalInformationSocial/InformacoesSocioStep.vue'
import NascionalidadeStep from '@/components/AdditionalInformationSocial/NascionalidadeStep.vue'
import EstadoCivilStep from '@/components/AdditionalInformationSocial/EstadoCivilStep.vue'
import EscolaridadeStep from '@/components/AdditionalInformationSocial/EscolaridadeStep.vue'
import RedesSocaisStep from '@/components/AdditionalInformationSocial/RedesSocaisStep.vue'
import EnderecoStep from '@/components/AdditionalInformationSocial/EnderecoStep.vue'
import InformacoesPjInstitucionalStep from '@/components/AdditionalInformationSocial/InformacoesPjInstitucionalStep.vue'
import InformacoesPjEnderecoStep from '@/components/AdditionalInformationSocial/InformacoesPjEnderecoStep.vue'
import InformacoesPjRedesSociaisStep from '@/components/AdditionalInformationSocial/InformacoesPjRedesSociaisStep.vue'
import InformacaoInstitucionalStep from '@/components/AdditionalInformationSocial/InformacaoInstitucionalStep.vue'
import FileUploadIndentidadeStep from '@/components/AdditionalInformationSocial/FileUploadIndentidadeStep.vue'
import FileUploadFotoIdentificacaoStep from '@/components/AdditionalInformationSocial/FileUploadFotoIdentificacaoStep.vue'
import FileUploadComprovanteEnderecoStep from '@/components/AdditionalInformationSocial/FileUploadComprovanteEnderecoStep.vue'
import FileUploadDeclaracaoIRStep from '@/components/AdditionalInformationSocial/FileUploadDeclaracaoIRStep.vue'
import FileUploadExtratosStep from '@/components/AdditionalInformationSocial/FileUploadExtratosStep.vue'
import FileUploadPjDeclaracaoMeiStep from '@/components/AdditionalInformationSocial/FileUploadPjDeclaracaoMeiStep.vue'
import FileUploadPjCertificadoMeiStep from '@/components/AdditionalInformationSocial/FileUploadPjCertificadoMeiStep.vue'
import FinishedStep from '@/components/AdditionalInformationSocial/FinishedStep.vue'

let components = Object.assign({
    'step-back-button': StepBackButton,
    'nome-completo-step': NomeCompletoStep,
    'telefones-step': TelefonesStep,
    'natureza-ocupacao-step': NaturezaOcupacaoStep,
    'renda-extra-step': RendaExtraStep,
    'outros-emprestimos-step': OutrosEmprestimosStep,
    'informacoes-socio-step' : InformacoesSocioStep,
    'nascionalidade-step': NascionalidadeStep,
    'estado-civil-step': EstadoCivilStep,
    'escolaridade-step': EscolaridadeStep,  
    'redes-sociais-step': RedesSocaisStep,
    'endereco-step': EnderecoStep,
    'informacoes-pj-institucional-step': InformacoesPjInstitucionalStep,
    'informacoes-pj-endereco-step': InformacoesPjEnderecoStep,
    'informacoes-pj-redes-sociais-step': InformacoesPjRedesSociaisStep,
    'informacao-institucional-step': InformacaoInstitucionalStep,
    'file-upload-identidade-step': FileUploadIndentidadeStep,
    'file-upload-foto-identificacao-step': FileUploadFotoIdentificacaoStep,
    'file-upload-comprovante-endereco-step': FileUploadComprovanteEnderecoStep,
    'file-upload-declaracao-ir-step': FileUploadDeclaracaoIRStep,
    'file-upload-extratos-step': FileUploadExtratosStep,
    'file-upload-pj-declaracao-mei-step': FileUploadPjDeclaracaoMeiStep,
    'file-upload-pj-certificado-mei-step': FileUploadPjCertificadoMeiStep,
    'finished-step': FinishedStep
})

export default {
  /* eslint-disable */
  data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      currentUser: null,
    }
  },
  components: components,
  computed: {
    currentStepComponent: function() {
      if(this.currentUser !== null) {

        if(!this.currentUser.Status || this.currentUser.Status === "" || this.currentUser.Status == "LIZA" || this.currentUser.Status == "PREAPROVADO") {
          this.currentUser.Status = "nome-completo";
        }

        return this.currentUser.Status + "-step";

      } else {
        return this.currentUser;
      }
    },
    progress: function() {
      const stepsAmount = Object.keys(components).length
      const currentStepNumber = Object.keys(components).indexOf(this.currentStepComponent) + 1
      return Math.round( (currentStepNumber * 100) / stepsAmount )
    },
    canGoPrevious: function() {
      if(!this.currentUser) { 
        return false
      }

      const stepsThatCantGoBack = ['nome-completo', 'finished', 'cancelado']
      return !stepsThatCantGoBack.includes(this.currentUser.Status)
    }
  },
  methods: {
    handleLoadingToggle(isLoading) {
      if(isLoading) {
        this.$store.commit(mutationTypes.START_LOADING)
      } else {
        this.$store.commit(mutationTypes.STOP_LOADING)
      }
    },
    updateUser: function(newData) {
      newData = Object.assign(newData, {StepType: 'next'})
      this.transitionName = 'slide-left'
      
     ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-social-informacoes`, {data: newData})
      .then(response => {
          
          //console.log("updateUser",response)
          this.currentUser = response.data

      }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING);})
    },
    onPrevious: function() {
      this.transitionName = 'slide-right'
      
      this.$store.commit(mutationTypes.START_LOADING)
      ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-social-informacoes`, {data: {StepType: 'previous'}})
        .then(response => {
          
          //console.log("onPrevious",response)
          this.currentUser = response.data
          this.$store.commit(mutationTypes.STOP_LOADING);

      }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING);})  
    },
  },
  created() {

    const solicitacaoId = this.$route.params.id

    this.$store.commit(mutationTypes.START_LOADING)
      ApiClient.get_GO(`solicitacoes/${solicitacaoId}`)
      .then(response => {
        this.currentUser = response.data
        this.$store.commit(mutationTypes.STOP_LOADING);
      })
      .catch(error => {
        window.error = error
        if(error.response && error.response.status == 404) {
          this.$router.push('/not-found')
        }

        if(error.response && error.response.status == 401) {
         window.location.href="#/";
        }
        this.$store.commit(mutationTypes.STOP_LOADING);
      })
  },
  beforeUpdate() {
    this.$Loading.update(this.progress);
  }
}
</script>


// WEBPACK FOOTER //
// src/views/AdditionalInformationSocial.vue